import {
  CabinItem,
  CabinType,
  InterFlightSortingTypes
} from "@website/ticket-ui/common/types";

export const DOM_FLIGHTS_PARAMETERS = [
  "departure_time_min",
  "departure_time_max",
  "arrival_time_min",
  "arrival_time_max",
  "airlines",
  "flight_min_duration",
  "flight_max_duration",
  "flight_stop_min",
  "flight_stop_max",
  "price_from",
  "price_to",
  "flightType",
  "filterCabinType"
] as const;

export const INTER_FLIGHTS_PARAMETERS = [
  "destinationStopCount",
  "originStopCount",
  "departure_time_min",
  "departure_time_max",
  "return_time_min",
  "return_time_max",
  "airlines",
  "flight_min_duration",
  "flight_max_duration",
  "visaTransits",
  "flight_stop_min",
  "flight_stop_max",
  "price_from",
  "price_to",
  "flightType",
  "originAirports",
  "destinationAirports",
  "originStopAirports",
  "destinationStopAirports",
  "originBaggages",
  "destinationBaggages"
] as const;

export const DOM_CABIN_TYPE = ["ECONOMY", "BUSINESS", "PREMIUM_ECONOMY"];
export const INTER_CABIN_TYPE = ["ECONOMY", "BUSINESS", "FIRST_CLASS"];

export const CABIN_TYPES = {
  "dom-flight": new Set(DOM_CABIN_TYPE),
  "inter-flight": new Set(INTER_CABIN_TYPE)
};

export const natioanlity = [
  {
    title: "ایرانی",
    value: "IR"
  },
  {
    title: "غیر ایرانی",
    value: "none-IR"
  }
];

export const passngersNaming = {
  ADULT: "بزرگسال",
  CHILD: "کودک",
  INFANT: "نوزاد"
};

export const default_sort = {
  label: "پیشنهاد اسنپ‌تریپ",
  value: "recommended" as InterFlightSortingTypes
};

export const cabin: Record<CabinType, CabinItem> = {
  ECONOMY: {
    text: "اکونومی"
  },
  BUSINESS: {
    text: "بیزینس"
  },
  FIRST_CLASS: {
    text: "فرست"
  },
  PREMIUM_ECONOMY: {
    text: "پریمیوم اکونومی",
    color: "secondary"
  }
};

export const DOMESTIC_SOLUTIONDETAIL_TABS = [
  {
    title: "جزییات",
    id: "detail"
  },
  {
    title: "کنسلی",
    id: "cancellation"
  },
  {
    title: "بار",
    id: "baggage"
  },
  {
    title: "قوانین",
    id: "flight-rules"
  }
];

export const INTL_SOLUTIONDETAIL_TABS = [
  {
    title: "جزییات",
    id: "detail"
  },
  {
    title: "کنسلی",
    id: "cancellation"
  },
  {
    title: "بار",
    id: "baggage"
  },
  {
    title: "قوانین",
    id: "flight-rules"
  },
  {
    title: "ویزا",
    id: "visa-rules"
  }
];

export const dom_flight_passenger_type = {
  ADL: "ADULT",
  INF: "INFANT",
  CHD: "CHILD"
};

const productTypeSchema = {
  bus: "bus",
  "dom-flights": "dom-flight",
  "inter-flights": "int-flight",
  train: "train"
} as const;

type ProductType = (typeof productTypeSchema)[keyof typeof productTypeSchema];

const ticketAppName = process.env
  .NEXT_PUBLIC_APP_NAME_TICKET as keyof typeof productTypeSchema;

export const productType: ProductType = productTypeSchema[ticketAppName];

export const BUS_FILTER_PARAMETERS = [
  "departureTimeSlot",
  // "company",
  "originTerminals",
  "destinationTerminals",
  "available"
] as const;

export const TRAIN_FILTER_PARAMETERS = [
  "departureTimeSlot",
  "arrivalTimeSlot",
  "departure_time_min",
  "departure_time_max",
  "arrival_time_min",
  "arrival_time_max",
  "companies",
  "trainTypes",
  "available",
  "price_from",
  "price_to"
] as const;

export const BUS_SOLUTIONDETAIL_TABS = [
  {
    title: "جزییات",
    id: "detail"
  },
  {
    title: "کنسلی",
    id: "cancellationRules"
  },
  {
    title: "قوانین",
    id: "generalRules"
  }
];

export const flightOverTimeModalContent =
  " قیمت و ظرفیت پروازها دائما در حال تغییر هستند. برای اطمینان از آخرین قیمت و وضعیت پروازها لطفا جستجو را بروز‌رسانی نمایید.";

export const solutionNotExistErrorCode = 404;
export const solutionNotExistErrorModal = {
  isOpen: true,
  type: "solution_not_exists",
  message: {
    title: "عدم امکان ادامه خرید",
    description: "امکان ادامه این خرید وجود ندارد. لطفاً مجدد جستجو کنید.",
    detail: ""
  }
};
